var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73584 3.06134L3.38711 8.55315C1.75992 10.1803 1.75987 12.8185 3.38705 14.4457C5.01424 16.0728 7.65243 16.0728 9.27961 14.4457L9.2803 14.445L14.4948 9.24276C14.8206 8.9177 15.3482 8.91833 15.6733 9.24415C15.9983 9.56997 15.9977 10.0976 15.6719 10.4227L10.4581 15.6242C10.458 15.6243 10.4582 15.624 10.4581 15.6242C8.18003 17.9019 4.48648 17.9021 2.20854 15.6242C-0.0681655 13.3475 -0.0695138 9.65702 2.2045 7.37863L7.55367 1.88638C9.18085 0.259194 11.8191 0.259245 13.4463 1.88643C15.0721 3.51225 15.0735 6.14738 13.4504 7.7749L8.10115 13.2672C7.12484 14.2435 5.54188 14.2435 4.56557 13.2671C3.58926 12.2908 3.58926 10.7079 4.56557 9.73161L10.0537 4.24345C10.3792 3.91802 10.9068 3.91802 11.2322 4.24345C11.5577 4.56889 11.5577 5.09653 11.2322 5.42196L5.74408 10.9101C5.41864 11.2356 5.41864 11.7632 5.74408 12.0886C6.06844 12.413 6.59366 12.4141 6.91935 12.0919L12.2677 6.60042C13.244 5.62411 13.2441 4.04125 12.2678 3.06494C11.2927 2.08983 9.71244 2.08863 8.73584 3.06134Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/paper-clip.cd49dced7e972304986dd979b97b8471.svg";
export { ForwardRef as ReactComponent };